<template>
  <!--safari浏览器10一下的复制提示-->
  <co-dialog
    v-model="visible"
    :title="$t('版本过低提示')"
    :show-footer="false"
    @close="close"
  >
    <div class="low-b-copy">
      <div class="text1">
        {{ prompt }}
      </div>
      <input
        ref="copyInput"
        class="copy-input"
        readonly=""
        :value="copyText"
      >
      <div class="text2">
        {{ $t("为确保正常使用网盘,请尽快升级您的浏览器版本") }}
      </div>
    </div>
  </co-dialog>
</template>
<script>
import coDialog from 'components/common/dialog/index.vue'

export default {
  name: 'LowBrowserCopy',
  components: {
    coDialog,
  },
  props: {
    copyText: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    prompt: {
      type: String,
      default() {
        return this.$t('您正在使用的浏览器版本过低,仅可手动复制链接地址:')
      },
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.inputSelect()
      }
    },
  },
  mounted() {
    this.inputSelect()
  },
  methods: {
    inputSelect() {
      this.$nextTick(() => {
        this.$refs.copyInput && this.$refs.copyInput.select()
      })
    },
    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="less" scoped>
.low-b-copy{
  padding: 30px 20px;
  min-width:480px;
  & .text1{
    line-height: 42px;
    font-size: 16px;
  }
  & .text2{
    line-height: 50px;
    font-size: 14px;
    color: #8E8E8E;
  }
  & .copy-input{
    width: 100%;
    border: none;
    height: 60px;
  }
}
</style>
